define("ember-cli-string-helpers/helpers/html-safe", ["exports", "@ember/component/helper", "@ember/template", "ember-cli-string-helpers/-private/create-string-helper"], function (_exports, _helper, _template, _createStringHelper) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.htmlSafe = _exports.default = void 0;
  const htmlSafe = _exports.htmlSafe = (0, _createStringHelper.default)(_template.htmlSafe);
  var _default = _exports.default = (0, _helper.helper)(htmlSafe);
});